import { generateRequest } from '.';

export const Action = {
  StationHours: {
    StationHoursPending: 'StationHours_PENDING',
    StationHoursCompleted: 'StationHours_FULFILLED',
    StationHoursFailed: 'StationHours_FAILED',
  },
};

export const fetchStationHours = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/hours`,
  types: [
    Action.StationHours.StationHoursPending,
    Action.StationHours.StationHoursCompleted,
    Action.StationHours.StationHoursFailed,
  ],
});
